import { InteractionType } from '@azure/msal-browser';
import { useMsalAuthentication } from '@azure/msal-react';
import { msalAuthScopes } from '@shared/auth/config/msalAuthScope/web.ts';

export function useLogin(type: InteractionType = InteractionType.Redirect) {
  const scopes = { scopes: msalAuthScopes };
  const { login: _login } = useMsalAuthentication(type, scopes);

  function login() {
    return _login(InteractionType.Redirect, scopes);
  }

  return { login };
}
